import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const PurchaseReturnService = {
  getList: async ({
    pageNumber = 1,
    perPage = 10,
    SupplierId = "",
    PurchaseId = "",
    StartDate = "",
    EndDate = "",
    SearchText = "",
  } = {}) => {
    const params = new URLSearchParams({
      Page: pageNumber.toString(),
      PageSize: perPage.toString(),
      ...(SupplierId && { SupplierId: SupplierId.toString() }),
      ...(PurchaseId && { PurchaseId: PurchaseId.toString() }),
      ...(StartDate && { StartDate }),
      ...(EndDate && { EndDate }),
      ...(SearchText && { SearchText }),
    });
    try {
      const res = await apiService.get(
        `/purchasereturns?${params.toString()}`,
        {
          headers: {
            Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
          },
        }
      );
      return res.data;
    } catch (err) {
      console.error("Error getting purchase return list. ERR:", err);
      throw err;
    }
  },

  create: async (postData) => {
    try {
      const response = await apiService.post("/purchasereturns", postData, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (err) {
      console.error("Error creating purchase return. ERR:", err);
      throw err;
    }
  },

  detail: async (id) => {
    try {
      const response = await apiService.get(`/purchasereturns/${id}`, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (err) {
      console.error("Error fetching purchase return detail. ERR:", err);
      throw err;
    }
  },
};

export default PurchaseReturnService;
